import React from 'react';

const HappyCustomers = ({ block, vars }) => {
  let stateClass = '';
  if (block.align === 'Left') {
    stateClass = 'stars-wr--left';
  }

  return (
    <section className={`block ${block._template} ${block.css_class_name}`}>
      <div className='container'>
        <div className={`stars-wr ${stateClass}`}>
          {block.title && (
            <h2 dangerouslySetInnerHTML={{ __html: block.title }}></h2>
          )}
          <p>
            We're rated <i className='fa fa-star'></i>{' '}
            <strong>
              {vars.trustpilot_rating_text} {vars.trustpilot_rating}
            </strong>{' '}
            out of 5 on{' '}
            <a
              href='https://www.trustpilot.com/review/bunny.net'
              target='_blank'
              rel='noopener'
            >
              Trustpilot
            </a>{' '}
            - Based on <strong>{vars.trustpilot_reviews} reviews</strong>
          </p>
        </div>
      </div>
    </section>
  );
};

export default HappyCustomers;
